export default "__VITE_ASSET__Cu4Ycd$z__"